export default __webpack_public_path__ + "static/media/Workday_logo.a055b802.svg";